import OmniApiClient from "./base";

const RESOURCE = "/keepa";

export const keepaApi = {
  listCredentials: (params = {}) =>
    OmniApiClient.get(`${RESOURCE}/credentials/`, { params }),

  createCredential: (data) =>
    OmniApiClient.post(`${RESOURCE}/credentials/`, data),

  updateCredential: (id, data) =>
    OmniApiClient.put(`${RESOURCE}/credentials/${id}`, data),

  deleteCredential: (id) =>
    OmniApiClient.delete(`${RESOURCE}/credentials/${id}`),

  getQueueStatus: () => OmniApiClient.get(`${RESOURCE}/queue/status`),

  getPipelineStatus: () => OmniApiClient.get(`${RESOURCE}/pipeline/status`),

  getDefaultQuerySelection: () =>
    OmniApiClient.get(`${RESOURCE}/query-selection/default`),

  startPipelineSyncAsins: (data = {}) =>
    OmniApiClient.post(`${RESOURCE}/pipeline/sync-asins/start`, data),

  startPipelineFetchProducts: (data = {}) =>
    OmniApiClient.post(`${RESOURCE}/pipeline/fetch-products/start`, data),

  stopPipeline: () => OmniApiClient.post(`${RESOURCE}/pipeline/stop`),

  syncAsins: (data = {}) => OmniApiClient.post(`${RESOURCE}/sync-asins`, data),

  fetchProducts: (data = {}) =>
    OmniApiClient.post(`${RESOURCE}/fetch-products`, data),

  analyzeProducts: (data = {}) =>
    OmniApiClient.post(`${RESOURCE}/analyze-products`, data),

  /** All steps in one request */
  scan: (data = {}) => OmniApiClient.post(`${RESOURCE}/scan`, data),

  addAsin: (data) => OmniApiClient.post(`${RESOURCE}/add-asin`, data),
};
